<template>
  <header class="header">
    <img src="@/assets/img/logo.jpg" alt="Katılım Emeklilik İnternet Şube" />
  </header>
</template>